import { render, staticRenderFns } from "./DashboardEquipamiento.vue?vue&type=template&id=278dbc40"
import script from "./DashboardEquipamiento.vue?vue&type=script&lang=js"
export * from "./DashboardEquipamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports